export default __webpack_public_path__ + "static/media/PROCEDURAL-DERMATOLOGY-NOTIFICATION-APPLICATION-25-26-BATCH.76eb4308.pdf";